<template>
	<div class="report_month_card">
		<div class="item" v-for="(item,index) in list" :key="index">
			<div class="value" :style="`color:${item.color}`">{{ item.value||'-' }}</div>
			<div class="unit" v-if="item.unit">{{ item.unit }}</div>
			<div class="name_row" v-if="item.name">
				<div class="name_item" v-for="(name) in item.name" :key="name">{{ name }}</div>
			</div>
			<div class="label_row" v-if="item.label">
				<div class="label_item" v-for="(label) in item.label" :key="label">{{ label }}</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
    name: 'reporMonthCard',
    props: {
        list: {
            type: Array,
            default: () => []
        }
    }
}
</script>
<style lang="less" scoped>
.report_month_card {
	display: flex;
	align-items: center;
	.item {
		min-height: 226px;
		flex: 1;
		margin-right: 16px;
		background-color: rgba(21, 197, 206, 0.05);
		border: 1px solid @primary;
		border-radius: 18px;
		padding: 40px 12px 32px 12px;
		text-align: center;
		.value {
			font-size: 44px;
			font-weight: bold;
			margin-bottom: 8px;
		}
		.unit {
			font-size: 20px;
			color: @gray-9;
			margin: 2px 0 8px;
		}
		.name_row {
			font-size: 22px;
			color: #2b2f36;
			height: 74px;
			div {
				height: 36px;
				line-height: 36px;
			}
		}
		.label_row {
			font-size: 20px;
			color: @gray-9;
			.label_item {
				margin-bottom: 12px;
			}
			.label_item:last-child {
				margin-bottom: 0;
			}
		}
	}
	.item:last-child {
		margin-right: 0;
	}
}
</style>